import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAssociated } from "app/models/core/lab/associated";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-soa',
  templateUrl: './soa.component.html'
})

export class SoaComponent implements OnInit {

  list: IAssociated[] = [];

  displayedColumns: string[] = ['labName', 'stateNumber', 'comments'];

  soaList: IAssociated[] = [];
  selectedSoa: IAssociated;
  dataSource = new MatTableDataSource<IAssociated>(this.list);

  listFilter = '';

  editMode = 'list';
  inputComments = '';
  inputLab: IAssociated;
  search = '';
  selected = '';
  inputLabName = '';
  inputStateNumber = '';
  label = '';

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;


  constructor(public labService: LabService,
    public sharedService: SharedService) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      this.setupTable();
    }
  }

  refreshAssociated() {
    this.labService.getAssociatedLab(this.labService.lab.stateNumber).subscribe(
      assoc => {
        this.labService.associated = assoc;
        this.setupTable();
        this.editMode = 'list';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  setupTable() {
    this.list = this.labService.associated.soaList;
    this.dataSource.data = this.list;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  add() {
    this.editMode = 'add';
    this.label = 'Enter state number or lab name.';
  }

  save() {
    if (this.inputLab != null) {
      this.inputLab.newAssociatedLabId = +this.inputLab.stateNumber;
      this.inputLab.labId = this.labService.lab.labId;
      this.inputLab.comments = this.inputComments;
      this.labService.saveAssociatedLab(this.inputLab, 'SOA').subscribe(
        () => {
          this.refreshAssociated();
        },
        error => console.log('error: ', error),
        () => {
        }
      );
    }
  }

  cancel() {
    this.editMode = 'list';
    this.soaList = [];
  }

  delete(): void {
    if (!confirm('Delete this record? Continue?')) {
      return;
    }

    this.labService.deleteAssociated(this.inputLab.soaId, 'SOA').subscribe(
      () => {
        this.refreshAssociated();
      },
      error => console.log('error: ', error),
      () => {
      }
    );

  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
    this.label = 'Enter state number or lab name';
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  rowclick(row: IAssociated) {
    this.editMode = 'edit';
    this.inputLab = row;
    this.inputComments = row.comments;
    this.inputLabName = row.labName;
    this.inputStateNumber = row.stateNumber;
  }

  updateFields(value: IAssociated) {
    this.inputLab = value;
    this.inputStateNumber = value.stateNumber;
  }


  getSoaList() {
     if (this.search != null && this.search != '') {
      this.labService.getSoaList(this.search).subscribe(
        res => {
          this.soaList = res;
          this.editMode = 'add';
          if (this.soaList.length == 0){
            this.label = 'No Labs found.';
          }
          else{
            this.label = 'Enter state number or lab name.';
          }
        },
        error => console.log('error', error),
        () => {
        }
      );
    }
  }

  clearSearch() {
    this.search = "";
    this.soaList = [];
    this.label = 'Enter state number or lab name.';
  }

}